<fm-balloon-header
  [avatar]="balloon?.avatar || defaultAvatar"
  [color]="balloon?.color"
  [defaultAvatar]="defaultAvatar"
  [hideHeader]="!balloon?.showHeader"
  [title]="balloon?.vehicleName"
  [subtitle]="balloon?.driverName"
  [vehicleFuelType]="vehicleFuelType"
  [hasBattery]="!!balloon?.evBatteryData"
  [showCriticalHealth]="hasHealthStatusViewPermission && showDeviceHealthDetails"
  [deviceHealthStatus]="this.vehicleHealthStatus?.healthStatus ?? ''"
></fm-balloon-header>

<fm-balloon-section *ngIf="hasHealthStatusViewPermission && showDeviceHealthDetails">
  <fm-device-health-balloon-section
    [vehicleHealthStatus]="this.vehicleHealthStatus"
    [hasPermissionForCameras]="hasCameraIssuesViewPermission"
    [hasPermissionToViewHealthStatus]="hasHealthStatusViewPermission"
    [deviceType]="balloon?.marker.type"
  ></fm-device-health-balloon-section>
</fm-balloon-section>

<fm-balloon-section
  *ngIf="balloon?.showStandardElements"
  id="vehicle-work-order-balloon-standard-elements"
  [showDivider]="
    balloon?.customElements?.length > 0 ||
    showLinks ||
    (showTachoInformation && balloon?.tacho?.isEnabled) ||
    balloon?.scheduler?.scheduledJobs?.length > 0 ||
    balloon?.evBatteryData
  "
>
  <div class="balloon-section__container">
    <div class="balloon-section__column balloon-section__column-one">
      <span
        *ngIf="balloon.status.isLastUpdateFromToday || (isEVChangesEnabled && balloon?.evBatteryData?.chargingState && formattedDuration)"
        >{{ formattedDuration }}</span
      >
      <span>
        <span *ngIf="balloon?.status.vehicleStatus !== EVehicleStatusType.Stopped" i18n="@@S_LAST_UPDATE">Last update</span>
        <span *ngIf="balloon?.status.vehicleStatus === EVehicleStatusType.Stopped" i18n="@@S_LAST_MOVEMENT">Last movement</span>:
        {{ balloon?.status.lastUpdateTime }}
      </span>
      <span *ngIf="balloon?.status?.closestGeoFence && balloon?.status?.closestGeoFence !== ''">{{ balloon?.status.closestGeoFence }}</span>
      <span *ngIf="balloon?.status.formattedAddress" [innerHTML]="balloon?.status.formattedAddress"></span>
      <span *ngIf="balloon?.isSearchingAddress" i18n="@@S_VEHICLESTATUS_BALLOON_LOCATING_ADDRESS">Finding address...</span>
      <span *ngIf="!balloon?.isSearchingAddress && !balloon?.status.formattedAddress" i18n="@@S_VEHICLESTATUS_BALLOON_ADDRESS_NOT_LOCATED"
        >Address not found</span
      >
    </div>
    <div
      *ngIf="balloon?.status.speed > 0 && !isChargingOrStoppedOrIdle && balloon?.status.speedString !== ''"
      class="balloon-section__column balloon-section__column-two"
    >
      <span class="balloon-standard-element__speed" [class.balloon-standard-element__speed-violated]="balloon?.status.violationSpeed > 0">
        <span i18n="@@S_SPEED">Speed</span>: {{ balloon?.status.speedString }}
      </span>
      <fm-speed-violation
        *ngIf="balloon?.status.violationSpeed > 0"
        [speed]="balloon?.status.violationSpeed"
        [speedLimitType]="speedLimitOption"
        [speedType]="balloon?.status.inrixSpeedLimitType"
        [country]="userCountry"
      ></fm-speed-violation>
    </div>
  </div>
</fm-balloon-section>

<fm-balloon-section *ngIf="showVehicleBalloonEcm && balloon?.vehicleEcm && balloon?.vehicleEcm?.remainingFuelPercentage > 0">
  <fm-ecm-fuel-info-balloon-section [vehicleEcm]="balloon.vehicleEcm"></fm-ecm-fuel-info-balloon-section>
</fm-balloon-section>

<fm-balloon-section *ngIf="balloon?.type === EPlotType.poweredAsset">
  <fm-asset-battery-balloon-section
    [remainingBatteryPercentage]="balloon?.vehicleEcm?.remainingBatteryPercentage"
  ></fm-asset-battery-balloon-section>
</fm-balloon-section>

<fm-balloon-section
  *ngIf="balloon?.customElements?.length > 0"
  id="vehicle-work-order-balloon-custom-elements"
  [showDivider]="
    showLinks ||
    (showTachoInformation && balloon?.tacho?.isEnabled) ||
    balloon?.scheduler?.scheduledJobs?.length > 0 ||
    balloon?.evBatteryData
  "
>
  <span *ngFor="let element of balloon?.customElements" [innerHTML]="element"></span>
</fm-balloon-section>

<fm-balloon-section
  *ngIf="balloon?.scheduler?.scheduledJobs?.length > 0"
  [showDivider]="showLinks || (showTachoInformation && balloon?.tacho?.isEnabled) || balloon?.evBatteryData"
>
  <fm-scheduler-balloon-section
    [scheduledJobs]="balloon?.scheduler?.scheduledJobs"
    (scheduledJobClicked)="onScheduledJobClicked($event)"
  ></fm-scheduler-balloon-section>
</fm-balloon-section>

<fm-balloon-section *ngIf="showTachoInformation && balloon?.tacho?.isEnabled" [showDivider]="showLinks || balloon?.evBatteryData">
  <lib-tacho-balloon-driving-info [tacho]="balloon?.tacho?.status"> </lib-tacho-balloon-driving-info>
</fm-balloon-section>

<fm-balloon-section *ngIf="balloon?.evBatteryData" [showDivider]="showLinks">
  <span class="ev-battery-information" i18n="@@S_BATTERY_INFO">Battery Information</span>
  <fm-ev-battery-section
    [isCharging]="balloon.status.vehicleStatus === EVehicleStatusType.Charging"
    [percentage]="balloon.evBatteryData.batteryPercentage"
    [userSettings]="userSettings"
    [vehicleStatus]="balloon.status.vehicleStatus"
    [batteryUpdateTime]="balloon.evBatteryData.batteryLastUpdateTime"
    [showBatteryPercentageOnRightSide]="true"
  >
  </fm-ev-battery-section>
</fm-balloon-section>

<fm-balloon-actions *ngIf="showLinks">
  <button
    mat-button
    class="vzc-small"
    id="btn-balloon-zoom-to"
    a7s-id="live-map-map-vehicle-info-card-zoom-to"
    i18n="@@S_ZOOM_TO"
    [disabled]="disableZoomTo"
    (click)="onZoomTo()"
  >
    Zoom To
  </button>
  <button
    mat-button
    class="vzc-small"
    id="btn-balloon-street-view"
    a7s-id="live-map-map-vehicle-info-card-street-view"
    i18n="@@S_STREETVIEW"
    [disabled]="!isStreetViewAvailable"
    (click)="onStreetView()"
  >
    Street View
  </button>
  <button
    mat-button
    class="vzc-small"
    *ngIf="permissions?.replay"
    id="btn-balloon-replay"
    a7s-id="live-map-map-vehicle-info-card-replay"
    i18n="@@S_REPLAY"
    (click)="onReplay()"
  >
    Replay
  </button>
  <button
    mat-button
    class="vzc-small"
    *ngIf="
      customBalloonFeatureEnabled &&
      permissions?.dispatchWindowMessages &&
      permissions?.dispatchWindowMessages !== EPermissionStatus.Disabled
    "
    id="btn-balloon-message"
    a7s-id="live-map-map-vehicle-info-card-message"
    i18n="@@S_MESSAGE"
    [disabled]="!balloon.hasNavigationDevice"
    (click)="onMessage()"
  >
    Message
  </button>
</fm-balloon-actions>
